var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"que-content-max-width"},[_c('q-section-header',{attrs:{"title":"Create Business"}},[_vm._v(_vm._s(""))]),_c('business-create-general')],1)}
var staticRenderFns = []

export { render, staticRenderFns }